<div class="geography-filter" *ngIf="isMegaMenuReady">
  <div class="all-geography" *ngIf="allGeography">
    <label
      nz-checkbox
      [ngModel]="allGeography.selected"
      [nzIndeterminate]="allGeography.partially_selected"
      (ngModelChange)="onAllGeographyChange($event)"
    >
      {{ allGeography.title }}
    </label>
    <!--  -->
  </div>
  <div class="popular-container">
    <div class="popular-text">
      <va-icon
        isFontAwesome="true"
        *ngIf="!isPopularExpanded"
        [name]="faCaretRight"
        class="fa-xs"
        (click)="expandPopular(true)"
      ></va-icon>
      <va-icon
        isFontAwesome="true"
        *ngIf="isPopularExpanded"
        [name]="faCaretDown"
        class="fa-xs"
        (click)="expandPopular(false)"
      ></va-icon>
      Popular
    </div>
    <ng-container
      *ngIf="isPopularExpanded && popularGeography && popularGeography.children"
    >
      <label
        *ngFor="let country of popularGeography.children"
        nz-checkbox
        [ngModel]="country.isSelected"
        [nzIndeterminate]="country.isInDeterminate"
        (ngModelChange)="onPopularGeographyChange($event, country)"
      >
        <div class="popular-area">
          <span>{{ country.title }}</span>
          <span>{{ country.count }}</span>
        </div>
      </label>
    </ng-container>
  </div>

  <nz-tree
    [nzData]="otherGeographies"
    nzCheckable
    nzMultiple
    [nzExpandedKeys]="otherGeoExpandedKeys"
    [nzCheckedKeys]="otherSelectedArray"
    (nzExpandChange)="onOtherGeoExpand($event)"
    (nzCheckBoxChange)="onOtherGeographyChange($event)"
    [nzTreeTemplate]="nzTreeTemplate"
  >
  </nz-tree>
  <ng-template #nzTreeTemplate let-node let-origin="origin">
    <div class="custom-tree-node" (change)="onOtherGeographyChange($event)">
      <span>{{ node.title }}</span>
      <span>{{ node.origin.count }}</span>
    </div>
  </ng-template>
</div>

<app-custom-skeleton
  *ngIf="!isMegaMenuReady"
  [customSkeletonConfig]="skeletonDefaultConfig"
  ngClass="industry-skeleton-title"
></app-custom-skeleton>
